"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allegroFormatVersionNames = exports.AllegroFormatVersion = void 0;
exports.formatVersionFromMagic = formatVersionFromMagic;
var AllegroFormatVersion;
(function (AllegroFormatVersion) {
    AllegroFormatVersion[AllegroFormatVersion["V_PRE_V16"] = 0] = "V_PRE_V16";
    AllegroFormatVersion[AllegroFormatVersion["V_160"] = 1] = "V_160";
    AllegroFormatVersion[AllegroFormatVersion["V_162"] = 2] = "V_162";
    AllegroFormatVersion[AllegroFormatVersion["V_164"] = 3] = "V_164";
    AllegroFormatVersion[AllegroFormatVersion["V_165"] = 4] = "V_165";
    AllegroFormatVersion[AllegroFormatVersion["V_166"] = 5] = "V_166";
    AllegroFormatVersion[AllegroFormatVersion["V_172"] = 6] = "V_172";
    AllegroFormatVersion[AllegroFormatVersion["V_174"] = 7] = "V_174";
    AllegroFormatVersion[AllegroFormatVersion["V_175"] = 8] = "V_175";
    AllegroFormatVersion[AllegroFormatVersion["V_180"] = 9] = "V_180";
})(AllegroFormatVersion || (exports.AllegroFormatVersion = AllegroFormatVersion = {}));
exports.allegroFormatVersionNames = {
    [AllegroFormatVersion.V_PRE_V16]: "Pre-V16",
    [AllegroFormatVersion.V_160]: "16.0",
    [AllegroFormatVersion.V_162]: "16.2",
    [AllegroFormatVersion.V_164]: "16.4",
    [AllegroFormatVersion.V_165]: "16.5",
    [AllegroFormatVersion.V_166]: "16.6",
    [AllegroFormatVersion.V_172]: "17.2",
    [AllegroFormatVersion.V_174]: "17.4",
    [AllegroFormatVersion.V_175]: "17.5",
    [AllegroFormatVersion.V_180]: "18.0",
};
const MAGIC_TO_VERSION = {
    0x00130000: AllegroFormatVersion.V_160,
    0x00130400: AllegroFormatVersion.V_162,
    0x00130c00: AllegroFormatVersion.V_164,
    0x00131000: AllegroFormatVersion.V_165,
    0x00131500: AllegroFormatVersion.V_166,
    0x00140400: AllegroFormatVersion.V_172,
    0x00140500: AllegroFormatVersion.V_172,
    0x00140600: AllegroFormatVersion.V_172,
    0x00140700: AllegroFormatVersion.V_172,
    0x00140900: AllegroFormatVersion.V_174,
    0x00140e00: AllegroFormatVersion.V_174,
    0x00141500: AllegroFormatVersion.V_175,
    0x00150000: AllegroFormatVersion.V_180,
};
function formatVersionFromMagic(magic) {
    // eslint-disable-next-line no-bitwise
    const masked = magic & 0xffffff00;
    const mapped = MAGIC_TO_VERSION[masked];
    if (mapped !== undefined) {
        return mapped;
    }
    // eslint-disable-next-line no-bitwise
    const majorVer = (magic >>> 16) & 0xffff;
    if (majorVer <= 0x0012) {
        return AllegroFormatVersion.V_PRE_V16;
    }
    throw new Error(`Unknown Allegro file version 0x${magic.toString(16).padStart(10, "0")} (rev ${majorVer - 3})`);
}
//# sourceMappingURL=formatVersion.js.map